var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDescriptiveClock = function SvgDescriptiveClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M12.001 21.8c-1.3 0-2.5-.2-3.7-.7-2.4-1.1-4.3-3-5.3-5.4-2.1-4.9.3-10.6 5.3-12.7 2.4-1 5.1-1 7.5 0 2.3 1 4.2 2.9 5.2 5.3s1 5.1 0 7.5c-1 2.4-2.9 4.3-5.3 5.3-1.2.4-2.4.7-3.7.7m0-18.1c-1.1 0-2.1.2-3.2.6-4.2 1.8-6.2 6.7-4.4 10.9.8 2 2.4 3.6 4.5 4.5 2 .8 4.3.8 6.3 0s3.6-2.4 4.5-4.5c.9-2.1.8-4.3 0-6.3s-2.4-3.6-4.5-4.5c-1.1-.4-2.1-.7-3.2-.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M11.701 7.2c.4 0 .8.3.8.8v4.2l3.3 2c.4.2.5.7.2 1-.2.4-.7.5-1 .2l-3.7-2.2c-.2-.1-.4-.4-.4-.6V8c.1-.4.4-.8.8-.8",
    clipRule: "evenodd"
  })));
};
export default SvgDescriptiveClock;